import React from "react"
import Panel, { Content, CommandBar, Command, Search } from "../Panel"
import { QueryParams } from "../QueryParamsContainer"
import { Table, Image, Button, Label } from "semantic-ui-react"
import Observer from "react-intersection-observer"
import sizes from "../helpers/semantic-ui-sizes"
import { push } from "../history"

const Songwriters = props => (
  <QueryParams>
    {queryParams => (
      <Panel title="Songwriters">
        <CommandBar>
          <Command fluid>
            <Search
              value={queryParams.params.songwritersQuery || ``}
              onChange={songwritersQuery =>
                queryParams.update({ songwritersQuery })
              }
            />
          </Command>
        </CommandBar>
        <Content
          style={{ padding: 0 }}
          loading={props.songwriters.isFetching}
          loadingText="Loading songwriters"
        >
          <Table basic="very" selectable style={{ marginTop: 0 }}>
            <Table.Body>
              {props.songwriters.data.map(item => (
                <Table.Row
                  key={item.id}
                  active={props.location.pathname.indexOf(item.id) !== -1}
                  onClick={() => {
                    push(`${ props.match.path }/${ item.id }`)
                  }}
                  style={{ cursor: `pointer` }}
                >
                  <Table.Cell
                    textAlign="left"
                    style={{
                      paddingLeft: `16px`,
                      width: `1%`,
                      whiteSpace: `nowrap`,
                      verticalAlign: `top`,
                    }}
                  >
                    {item.image ? (
                      <Image
                        size="mini"
                        src={item.image.url + `?width=${ sizes.mini }`}
                        style={{
                          marginTop: `auto`,
                          marginBottom: `auto`,
                        }}
                      />
                    ) : (
                      <div
                        className="ui tiny image"
                        style={{
                          width: `${ sizes.mini }px`,
                          height: `${ sizes.mini }px`,
                          border: `dashed 2px rgb(140,140,140)`,
                        }}
                      />
                    )}
                  </Table.Cell>
                  <Table.Cell style={{ paddingLeft: `16px` }}>
                    <div
                      style={{
                        minHeight: `40px`,
                        display: `flex`,
                        flexDirection: `column`,
                        justifyContent: `center`,
                      }}
                    >
                      <span>{item.name}</span>
                      <small>{item.description}</small>
                    </div>
                  </Table.Cell>
                  <Table.Cell
                    textAlign="right"
                    style={{
                      paddingRight: `16px`,
                      width: `1%`,
                      whiteSpace: `nowrap`,
                    }}
                  >
                    {item.featured ? <Label>Featured</Label> : null}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          {props.songwriters.next && (
            <Observer
              onChange={inView =>
                inView &&
                !props.songwriters.isFetching &&
                props.songwriters.fetch(true)
              }
              rootMargin="610px"
            >
              <div
                style={{
                  width: `100%`,
                  display: `flex`,
                  justifyContent: `center`,
                  padding: `3em`,
                }}
              >
                <Button
                  basic
                  content="Load more..."
                  onClick={() => props.songwriters.fetch(true)}
                  loading={props.songwriters.isFetchingNext}
                />
              </div>
            </Observer>
          )}
          {!props.songwriters.next && !props.songwriters.isFetching && (
            <div
              style={{
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                minHeight: `122px`,
              }}
            >
              <Button
                basic
                onClick={() =>
                  push(
                    `/songwriters/new`,
                    queryParams.params.songwritersQuery &&
                      queryParams.params.songwritersQuery.length > 0
                      ? { name: queryParams.params.songwritersQuery }
                      : {}
                  )
                }
              >
                {queryParams.params.songwritersQuery &&
                queryParams.params.songwritersQuery.length > 0 ? (
                  <span>
                    Add{` `}
                    <strong>{queryParams.params.songwritersQuery}</strong>
                  </span>
                ) : (
                  `Add missing songwriter`
                )}
              </Button>
            </div>
          )}
        </Content>
      </Panel>
    )}
  </QueryParams>
)

export default Songwriters
